import React from "react";
import "../punctualityprintCss.css";
import { sumArrayOfObjects } from "../../../../Utilitie";
const PunPerformance = ({ data, groupSum }) => {
  const tableHead = [
    "train_type",
    "SCH",
    "EXCP",
    "ACT_SCH",
    "NOT_REPORTED",
    "RPT",
    "BT",
    "RT",
    "MKUP",
    "NLT",
    "TotalRT",
    "LT",
    "LT_01_15",
    "LT_16_30",
    "LT_31_45",
    "LT_46_60",
    "LT_ABOVE_60",
    "PP_CFY_DAY",
    "PP_LFY_DAY",
    "PP_FY_DAY_DIFF",
    "PP_CFY_MONTH",
    "PP_LFY_MONTH",
    "PP_FY_MONTH_DIFF",
    "PP_CFY",
    "PP_LFY",
    "PP_FY_DIFF",
  ];
  const mGroup = data.filter((obj) => obj.group_type === "M");
  const pGroup = data.filter((obj) => obj.group_type === "P");
  const sGroup = data.filter((obj) => obj.group_type === "S");
  const oGroup = data.filter((obj) => obj.group_type === "O");
  const mpsGroup = groupSum.group_MPS;
  mGroup.push(groupSum.group_M[0]);
  pGroup.push(groupSum.group_P[0]);
  sGroup.push(groupSum.group_S[0]);
  // oGroup.push(groupSum.group_O[0]);
  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="newUiBody">
      TESTING
      <div id="print-section">
        <div style={{ height: 0, overflow: "hidden" }}>&nbsp;</div>

        <div className="table-responsive m-0 p-0">
          <table className="table  newUiTable table-hover table-striped">
            <thead>
              <tr>
                <th style={{ width: "10px", fontSize: "11px" }}>Sr</th>
                {tableHead.map((head, i) => {
                  return (
                    <th
                      className="text-wrap "
                      style={{ width: "20px", fontSize: "11px" }}
                      key={i}
                    >
                      {
                        head
                          .replace(/LT_/g, "")
                          .replace(/PP_/g, "")
                          .replace(/_/g, " ")
                        // .slice(0, 7)
                      }
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody style={{ fontSize: "11px" }}>
              <tr style={{ background: "white", color: "black" }}>
                <td className="m-0 p-0 border border-dark" colSpan={27}>
                  Mail-Express group (M)
                </td>
              </tr>
              {mGroup.map((mObj, j) => {
                return (
                  <tr className="m-0 p-0 border border-dark" key={j}>
                    <td> {j + 1}</td>
                    {tableHead.map((obj, k) => {
                      return (
                        <React.Fragment key={k}>
                          <td className="m-0 p-0 border border-dark">
                            {" "}
                            {mObj[obj] === 0 || mObj[obj] === "0"
                              ? ""
                              : typeof mObj[obj] === "number"
                              ? mObj[obj].toFixed(2)
                              : obj === "train_type"
                              ? mObj.train_type
                                ? mObj[obj]
                                : "Total"
                              : mObj[obj]}
                          </td>
                        </React.Fragment>
                      );
                    })}
                  </tr>
                );
              })}
              <tr style={{ background: "white", color: "black" }}>
                <td className="m-0 p-0 border border-dark" colSpan={27}>
                  Passenger group (P)
                </td>
              </tr>
              {pGroup.map((mObj, j) => {
                return (
                  <tr key={j}>
                    <td className="m-0 p-0 border border-dark"> {j + 1}</td>
                    {tableHead.map((obj, k) => {
                      return (
                        <React.Fragment key={k}>
                          <td className="m-0 p-0 border border-dark">
                            {" "}
                            {mObj[obj] === 0 || mObj[obj] === "0"
                              ? ""
                              : typeof mObj[obj] === "number"
                              ? mObj[obj].toFixed(2)
                              : obj === "train_type"
                              ? mObj.train_type
                                ? mObj[obj]
                                : "Total"
                              : mObj[obj]}
                          </td>
                        </React.Fragment>
                      );
                    })}
                  </tr>
                );
              })}
              <tr style={{ background: "white", color: "black" }}>
                <td className="m-0 p-0 border border-dark" colSpan={27}>
                  group (S)
                </td>
              </tr>
              {sGroup.map((mObj, j) => {
                return (
                  <tr key={j}>
                    <td className="m-0 p-0 border border-dark"> {j + 1}</td>
                    {tableHead.map((obj, k) => {
                      return (
                        <React.Fragment key={k}>
                          <td className="m-0 p-0 border border-dark">
                            {" "}
                            {mObj[obj] === 0 || mObj[obj] === "0"
                              ? ""
                              : typeof mObj[obj] === "number"
                              ? mObj[obj].toFixed(2)
                              : obj === "train_type"
                              ? mObj.train_type
                                ? mObj[obj]
                                : "Total"
                              : mObj[obj]}
                          </td>
                        </React.Fragment>
                      );
                    })}
                  </tr>
                );
              })}
              <tr style={{ background: "white", color: "black" }}>
                <td className="m-0 p-0 border border-dark" colSpan={27}>
                  Group (M+P+S)
                </td>
              </tr>
              {mpsGroup.map((mObj, j) => {
                return (
                  <tr key={j}>
                    <td className="m-0 p-0 border border-dark"> {j + 1}</td>
                    {tableHead.map((obj, k) => {
                      return (
                        <React.Fragment key={k}>
                          <td className="m-0 p-0 border border-dark">
                            {mObj[obj] === 0 || mObj[obj] === "0"
                              ? ""
                              : typeof mObj[obj] === "number"
                              ? mObj[obj].toFixed(2)
                              : obj === "train_type"
                              ? mObj.train_type
                                ? mObj[obj]
                                : "Total"
                              : mObj[obj]}
                          </td>
                        </React.Fragment>
                      );
                    })}
                  </tr>
                );
              })}{" "}
              <tr style={{ background: "white", color: "black" }}>
                <td className="m-0 p-0 border border-dark" colSpan={27}>
                  Other group (O)
                </td>
              </tr>
              {oGroup.map((mObj, j) => {
                return (
                  <tr key={j}>
                    <td className="m-0 p-0 border border-dark"> {j + 1}</td>
                    {tableHead.map((obj, k) => {
                      return (
                        <React.Fragment key={k}>
                          <td className="m-0 p-0 border border-dark">
                            {mObj[obj] === 0 || mObj[obj] === "0"
                              ? ""
                              : typeof mObj[obj] === "number"
                              ? mObj[obj].toFixed(2)
                              : obj === "train_type"
                              ? mObj.train_type
                                ? mObj[obj]
                                : "Total"
                              : mObj[obj]}
                          </td>
                        </React.Fragment>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div className="no-print">
        <button className="btn btn-success" onClick={handlePrint}>
          Print
        </button>
      </div>
    </div>
  );
};
export default PunPerformance;
